import { Column, ColumnChooserModel, ColumnChooserNode } from './column-chooser.model';

export interface CustomMapper {
  fields?: string[];
  ignoreChildrenSelection?: boolean;
}

export class CustomChooserModel extends ColumnChooserModel {
  private readonly mappedColumns: Record<string, CustomMapper>;

  public castToCustomModel(): ColumnChooserNode[] {
    return this.columns.map((node) => {
      const mappedColumn = this.mappedColumns[node.headerName] || this.mappedColumns[node.field];

      if (mappedColumn) {
        node.checked = ColumnChooserModel.areSomeChildrenChecked(node.children || []);
        node.children = [];
        node.indeterminate = false;

        node.ignoreChildrenSelection = mappedColumn.ignoreChildrenSelection || false;
      }

      return node;
    });
  }

  constructor(
    protected columnDefs: Column[],
    protected columnMapper: Record<string, CustomMapper>
  ) {
    super(columnDefs);
    this.mappedColumns = columnMapper;
    this.columns = this.castToCustomModel();
  }

  public reapplyCustomMapping(): void {
    this.columns = this.castToCustomModel();
  }

  public restoreChildrenToMappedColumns(columns: ColumnChooserNode[]): ColumnChooserNode[] {
    return columns.map((column) => {
      const mappedColumn =
        this.mappedColumns[column.headerName] || this.mappedColumns[column.field];

      if (mappedColumn) {
        column.children =
          mappedColumn.fields?.map((field) => ({
            checked: column.checked,
            children: [],
            field,
            headerName: '',
            pinned: column.pinned,
          })) || [];
      }

      return column;
    });
  }
}
